import React from "react"

import SEO from "../components/SEO"
import Navigation from "../components/Navigation"


const OurWorkPage = () => {
    return (
        <>
            <SEO title="Our Work"/>
            <Navigation />
        </>
    )
}

export default OurWorkPage
